<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Tambah Tarif</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nama Paket</label>
                                                <input type="text" class="form-control" placeholder="Nama Area...">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Tarif Paket (Pastikan Tarif paket tidak pakai titik/koma. Mis : 50000)</label>
                                                <input type="number" class="form-control" placeholder="Tarif Paket...">
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary">Simpan</button>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
	const data = reactive({
		
    })

	const tambah = {
      	data: reactive({
			  
      	}),
		submit() {
			var datax = {
          		token: 'TangTung '+sessionStorage.getItem('myToken')
        	};
				
			var apiUrl = inter.tarif();
			myGlobal.call(datax,apiUrl).then(x => {
				//console.log(JSON.stringify(x));
				if (x.status == true) {
					
				} else {
					//alert(x.pesan);
				}
			})
		}
    }
    return {
      data, 
      tambah
    }

  },
  mounted () {
    document.title = "Tambah Tarif Voucher";
  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/voucher/tambah.vue